import { render, staticRenderFns } from "./simplifyCallable.vue?vue&type=template&id=0810f79a&scoped=true"
import script from "./simplifyCallable.vue?vue&type=script&lang=js"
export * from "./simplifyCallable.vue?vue&type=script&lang=js"
import style0 from "./simplifyCallable.vue?vue&type=style&index=0&id=0810f79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810f79a",
  null
  
)

export default component.exports